import axios from 'axios';

const updateSettings = params => axios.put('sms/settings', params);

const acceptPolicy = () => axios.put('sms/settings/accept');

export { updateSettings, acceptPolicy };
